export default __webpack_public_path__ + "static/story-f7316250639f81a7c266f4b83d137679.png";